module.exports = __webpack_public_path__ + "static/media/img-horizontal-buildings@2x.eb4bdd16.png";